// TEMP DEBUG — remove once the Domain A property-tax investigation is closed.
// Shared, numbered logger so log order is unambiguous across the multiple
// files/components involved in the annualPropertyTax flow (address enrichment,
// PropertyDetailsSection, useUserTemplate, getTitleEscrowData, ManualSheetSection),
// even when their effects interleave asynchronously.
let seq = 0;

export function taxDebugLog(label, data) {
  seq += 1;
  console.log(
    `%c[TaxDebug #${String(seq).padStart(2, "0")}] ${label}`,
    "color:#fff;background:#7c3aed;padding:2px 6px;border-radius:3px;font-weight:bold;",
    data,
  );
}
